export const QUOTE_APPLY_DISCOUNT = "QUOTE_APPLY_DISCOUNT";
export const QUOTE_REMOVE_DISCOUNT = "QUOTE_REMOVE_DISCOUNT";
export const QUOTE_RESET_DISCOUNT = "QUOTE_RESET_DISCOUNT";

export const quoteApplyDiscount = ({ discountCode }) => {
  return {
    type: QUOTE_APPLY_DISCOUNT,
    payload: {
      discountCode,
    },
  };
};

export const quoteResetDiscount = () => {
  return {
    type: QUOTE_RESET_DISCOUNT,
  };
};

export const quoteRemoveDiscount = () => {
  return {
    type: QUOTE_REMOVE_DISCOUNT,
  };
};
